import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { changePassword, setToken } from "../api";

export function ChangePasswordPage() {
  const { t } = useTranslation(["dashboard", "common"]);
  const navigate = useNavigate();
  const [oldPwd, setOldPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    if (newPwd.length < 8) {
      setError(t("changePassword.minLength"));
      return;
    }
    if (newPwd !== confirm) {
      setError(t("changePassword.mismatch"));
      return;
    }
    setLoading(true);
    try {
      await changePassword(oldPwd, newPwd);
      setOk(true);
      setToken(null);
      setTimeout(() => navigate("/login"), 1500);
    } catch (exc) {
      setError(String(exc));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page narrow">
      <h2>{t("changePassword.title")}</h2>
      {ok ? (
        <p>{t("changePassword.success")}</p>
      ) : (
        <form onSubmit={onSubmit} className="stack-form">
          <label>
            {t("changePassword.current")}
            <input type="password" value={oldPwd}
                   onChange={(e) => setOldPwd(e.target.value)} required />
          </label>
          <label>
            {t("changePassword.new")}
            <input type="password" value={newPwd}
                   onChange={(e) => setNewPwd(e.target.value)} required />
          </label>
          <label>
            {t("changePassword.confirm")}
            <input type="password" value={confirm}
                   onChange={(e) => setConfirm(e.target.value)} required />
          </label>
          {error && <p className="error">{error}</p>}
          <button type="submit" disabled={loading}>
            {loading ? t("common:actions.saving") : t("common:actions.save")}
          </button>
        </form>
      )}
    </div>
  );
}
